import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { useCallback } from "react";

export function useAddAnalyticsAppEvent(
	environmentAppId: number
): { addEvent(): void; } {
	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);

	const addAppEventHandler = useCallback(
		(): void => {
			addAnalyticsAppEvent({
				installedAppId: environmentAppId
			});
		},
		[
			addAnalyticsAppEvent,
			environmentAppId
		]
	);

	return {
		addEvent: addAppEventHandler
	};
}